export default __webpack_public_path__ + "static/media/2728 knife block A side.a03aa0ee.png";